import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import {addNewFamily} from "../../service/FamilyService";
import {useGlobalSpinnerContext} from "../../context/GlobalSpinnerContext";
import {useHistory} from "react-router-dom";

const AddFamily = (props) => {
  const [family, setFamily] = useState({
    firstName: props.family ? props.family.firstName : '',
    lastName: props.family ? props.family.lastName : '',
    phone: props.family ? props.family.phone : '',
    address: props.family ? props.family.address : '',
    description: props.family ? props.family.description : '',
    descriptionEn: props.family ? props.family.descriptionEn : '',
    voucherLimit: props.family ? props.family.voucherLimit : ''
  });

  const history = useHistory();
  const [, showSpinner, hideSpinner] = useGlobalSpinnerContext()

  const [errorMsg, setErrorMsg] = useState('');
  const [error, setError] = useState(false);
  const { firstName, lastName, phone, address, description, descriptionEn, voucherLimit } = family;

  const saveFamily = (family) => {
    showSpinner();
    addNewFamily(family)
      .then(response => {
        console.log(response);
        history.push("/families");
      })
      .catch(error => {
        console.log(error);
        setError(true);
      })
      .finally(() => hideSpinner());
  }

  const handleOnSubmit = (event) => {
    event.preventDefault();
    const values = [firstName, lastName, phone, address, description, descriptionEn, voucherLimit];
    let errorMsg = '';

    const allFieldsFilled = values.every((field) => {
      const value = `${field}`.trim();
      return value !== '' && value !== '0';
    });

    if (allFieldsFilled) {
      const family = {
        firstName,
        lastName,
        phone,
        address,
        description,
        descriptionEn,
        voucherLimit
      };
      saveFamily(family);
    } else {
      errorMsg = 'Please fill out all the fields.';
    }
    setErrorMsg(errorMsg);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case 'phone':
        if (value === '' || value.match(/^\d{1,}$/)) {
          setFamily((prevState) => ({
            ...prevState,
            [name]: value
          }));
        }
        break;
      case 'voucherLimit':
        if (value === '' || value.match(/^\d{1,}$/)) {
          setFamily((prevState) => ({
            ...prevState,
            [name]: value
          }));
        }
        break;
      default:
        setFamily((prevState) => ({
          ...prevState,
          [name]: value
        }));
    }
  };

  return (
    <div className="m-5 main-form">
      <h3>Add new family</h3>
      <hr/>
      {errorMsg && <p className="alert-danger">{errorMsg}</p>}
      <Form onSubmit={handleOnSubmit}>
        <Form.Group controlId="firstName">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            className="input-control"
            type="text"
            name="firstName"
            value={firstName}
            placeholder="Enter first name"
            onChange={handleInputChange}
          />
        </Form.Group>
        <Form.Group controlId="lastName">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            className="input-control"
            type="text"
            name="lastName"
            value={lastName}
            placeholder="Enter last name"
            onChange={handleInputChange}
          />
        </Form.Group>
        <Form.Group controlId="phone">
          <Form.Label>Phone</Form.Label>
          <Form.Control
            className="input-control"
            type="text"
            name="phone"
            value={phone}
            placeholder="Enter phone number"
            onChange={handleInputChange}
          />
        </Form.Group>
        <Form.Group controlId="address">
          <Form.Label>Address</Form.Label>
          <Form.Control
            className="input-control"
            type="text"
            name="address"
            value={address}
            placeholder="Enter address"
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group controlId="description">
          <Form.Label>Description</Form.Label>
          <Form.Control
            className="input-control"
            as="textarea"
            name="description"
            value={description}
            placeholder="Enter description"
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group controlId="descriptionEn">
          <Form.Label>English Description</Form.Label>
          <Form.Control
            className="input-control"
            as="textarea"
            name="descriptionEn"
            value={descriptionEn}
            placeholder="Enter english description"
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group controlId="voucherLimit">
          <Form.Label>Voucher Limit</Form.Label>
          <Form.Control
            className="input-control"
            type="text"
            name="voucherLimit"
            value={voucherLimit}
            placeholder="Enter voucher limit"
            onChange={handleInputChange}
          />
        </Form.Group>

        {error && <div className="mt-2 mb-2 p-3 alert-danger">Error occurred while saving</div>}
        <Button variant="primary" type="submit" className="mt-3 submit-btn btn-info">
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default AddFamily;
